module.exports = __webpack_public_path__ + "assets/img/card_icon_back.603e20a2.png";